<script setup>
import { useRouter } from 'vue-router'
import { onMounted, ref, nextTick } from 'vue'
import { getOpponentdetails } from '@/services/service'
const router = useRouter()

const route = useRouter().currentRoute.value;

const key = ref(null);
const rank_id = ref(null);
const user_name = ref(null);

key.value = route.query.key;
rank_id.value = route.query.rank_id;
user_name.value = route.query.user_name;

const ranking = ref(null);
// ranking.value = Number(route.query.ranking);

import BScroll from '@better-scroll/core';
const detailsScrollBox = ref(null)

// const goToFrontPage = () => {
//   router.push('/')
// }
const goToFrontPage = () => {
  router.push({
        path: '/matchpage',
        query: {
            id: rank_id.value,
        },
        replace: false
    })
}



onMounted(async () => {
  try {
    ranking.value = await getOpponentdetails(rank_id.value,key.value)
    
    nextTick(() => {
      new BScroll(detailsScrollBox.value, {
        useTransition: true,
        click: true,
        mouseWheel: true,
      })
    })


  } catch (error) {
    console.error('获取用户详情失败:', error)
  }
})

</script>

<template>
  <div class="details-page" v-if="ranking">
    <div @click="goToFrontPage" class="left-box">
      <img src="./img/fhsyj.png" alt="" style="width: .5625rem;height: 1rem;">
    </div>
    <div class="content-title-box">
      <div class="border-box"></div>
      <div class="title-box">对战详情</div>
    </div>

    <div class="content-scroll-box" ref="detailsScrollBox" v-if="ranking.length>0" >
      <div class="for-content-box">
        <div v-for=" item in ranking" :key="item.id">

          <div class="content-box-item">
            <div class="content-box-item-top" :class="{
              'fail': item.competition_results === 0,
              'win': item.competition_results === 1
            }">
              <div class="content-box-item-top-left">
                <div class="type-name" v-if="item.operate_type === 1">
                  赛事变化
                </div>
                <div class="type-name" v-else>
                  休眠变化
                </div>
                <div class="time">{{ item.operate_time }}</div>
              </div>
              <div class="content-box-item-top-right failType" v-if="item.competition_results === 0">
                {{ item.operate_value }}
              </div>
              <div class="content-box-item-top-right winType" v-else>
                +{{ item.operate_value }}
              </div>
            </div>

            <div class="content-box-item-bottom" v-if="item.operate_type === 1">

              <div class="item-event-name-box">
                <div class="item-event-name-box-left">
                  <div class="item-event-name-box-left-img"></div>
                  <div class="item-event-name-box-left-name"> {{ item.event_name }}</div>
                </div>
                <div class="lunci">第 <span style="color:blue;font-size:16px;margin-right:5px">{{ item.games }}</span>轮</div>
              </div>

            </div>

            <div class="vs-box" v-if="item.operate_type === 1">

              <div class="vs-item-box">
                <div class="vs-item-name-box">
                  <div class="win-img">
                    <img v-if="item.competition_results === 1" src="./img/slhg.png" alt="">
                  </div>
                  <div class="vs-item-name">{{ user_name  }}</div>
                </div>

                <div class="vs-item-left-number win-number" v-if="item.competition_results === 1">胜</div>
                <div class="vs-item-left-number fail-number" v-if="item.competition_results === 0">负</div>
                <!-- {{ item.score.split('-')[0] }} -->
              </div>

              <div class="vs-text">VS</div>

              <div class="vs-item-box">
                <div class="vs-item-left-number win-number" v-if="item.competition_results === 0">胜</div>
                <div class="vs-item-left-number fail-number" v-if="item.competition_results === 1">负</div>
                <div class="vs-item-name-box">
                  <div class="win-img">
                    <img v-if="item.competition_results === 0" src="./img/slhg.png" alt="">
                  </div>
                  <div class="vs-item-name">{{ item.opponent }}</div>
                </div>
              </div>

            </div>
            <div class="vs-box" v-else>
              <div class="vs-item-rule">
                根据赛事规则，一个月未参加比赛，扣除{{ item.operate_value }}赛事积分
              </div>
            </div>
      
          </div>
        </div>
      </div>
    </div>
    <div class="content-scroll-box" v-else>
      <div class="no-content-box-img">
        该选手暂无等级分变化
      </div>
    </div>

  </div>
</template>


<style scoped lang="less">
.details-page {
  width: 100vw;
  height: 100vh;
  background-color: #F5F5F5;
  font-size: 16px;
  position: absolute;
  padding: 0 .75rem .75rem .75rem;
  overflow: hidden;

  .left-box {
    width: 100%;
    height: 2.5rem;
    margin-left: 0.5rem;
    display: flex;
    align-items: center;
  }
  .lunci{
    text-align:left;
    font-size:16px;
    width:60px;
  }
  .rank-1 {
    background-image: url('./img/1stbj.png');
  }

  .rank-2 {
    background-image: url('./img/2ndbj.png');
  }

  .rank-3 {
    background-image: url('./img/3rdbj.png');
  }

  .rank-default {
    background-image: url('./img/sythbj.png');
  }

  .header-box {
    width: 100%;
    height: 11rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    border-radius: .3125rem;

    .header-position-box {
      position: absolute;
      top: 5rem;
      left: 1.5rem;

      .header-name {
        font-size: 1rem;
        color: #fff;
        font-weight: 600;
      }

      .header-points {
        margin-top: -0.5rem;
        width: 100%;
        height: 4.125rem;
        font-size: 3.125rem;
        color: #fff;
        font-weight: 700;
      }
    }

  }

  .content-title-box {
    margin: 1rem 0;
    display: flex;
    align-items: center;

    .border-box {
      height: 1rem;
      border-left: .3125rem solid #3378EB;
      margin-right: 0.5rem;
      border-radius: 0.5rem;
    }

    .title-box {
      font-size: 1.25rem;
      font-weight: 600;
    }
  }

  .content-scroll-box {
    width: 100%;
    height: calc(100vh - 17.5rem);
    overflow: hidden;

    .for-content-box {
      width: 100%;
      // height: 100rem;

    }

    .content-box-item {
      width: 100%;
      height: 9.375rem;
      background-color: #fff;
      border-radius: .3125rem;
      overflow: hidden;
      margin-bottom: 1rem;

      .win {
        background: linear-gradient(to right, #5B8EFF, #C8ECFF);
      }

      .fail {
        background: linear-gradient(to right, #FF5B5B, #FFE2C8);
      }

      .content-box-item-top {
        width: 100%;
        height: 2.6875rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0.5rem;

        .content-box-item-top-left {
          height: 100%;
          display: flex;
          align-items: center;
          color: #fff;

          .type-name {
            font-size: 1.125rem;
            font-weight: 600;
          }

          .time {
            margin-left: 0.5rem;
            font-size: 1rem;
            line-height: 100%;
            color: #fff;
          }
        }

        .content-box-item-top-right {
          font-size: 1.125rem;
          font-weight: 600;
        }

        .failType {
          color: #EB3333;
        }

        .winType {
          color: #3378EB;
        }
      }

      .content-box-item-bottom {
        .item-event-name-box {
          display: flex;
          padding: 0.5rem;

          .item-event-name-box-left {
            display: flex;
            align-items: center;

            .item-event-name-box-left-img {
              width: .5rem;
              height: .5rem;
              border: 0.2rem solid #3378EB;
              border-radius: 50%;
              margin-right: 0.3rem;
            }

            .item-event-name-box-left-name {
              margin-right:0.5rem;
              font-size: 1rem;
              font-weight: 600;
              overflow:hidden;
            }
          }

          .item-event-name-box-right {
            font-size: 1rem;
            font-weight: 600;
          }
        }
      }

      .vs-box {
        width: 18rem;
        height: 2.125rem;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;

        .vs-item-rule {
          width: 20.1563rem;
          height: 2.125rem;
          margin-top: 2rem;
          font-size: 1rem;
          font-weight: 700;
          color: #333333;
          text-align: left;
        }

        .vs-item-box {
          display: flex;
          align-items: flex-end;
          font-size: 1rem;

          .vs-item-left-number {
            font-size: 1.25rem;
            margin: 0 1.5rem;
          }

          .vs-item-right-number {
            font-size: 1.25rem;
            margin: 0 1.5rem;
          }

          .win-number {
            color: #3378EB;
          }

          .fail-number {
            color: #EB3333;
          }

          .vs-item-name-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .win-img {
              width: .9375rem;
              height: .6875rem;
            }

            .vs-item-name {
              width: 6.25rem;
              text-align: center;
              font-size: 1rem;
              color: #333333;
              // font-weight: 600;
            }
          }
        }

        .vs-text {
          width: 1.3125rem;
          height: 2rem;
          display: flex;
          align-items: flex-end;
          font-size: 1rem;
          font-weight: 700;
          color: #3378EB;
        }
      }
    }
  }
  .no-content-box-img{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 4rem;
    font-size: 1.3rem;
    color: #333333;
  }
}
</style>